import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../../redux/root-reducer";
import { Dispatch } from "redux";
import { fetchApi } from "../../../../redux/fetch/fetch.actions";
import { useRouteMatch } from "react-router-dom";
import Loading from "../../../../components/loading/loading.component";
import QuestionActionAPI, {
    IInsertQuestionPayload,
} from "../../../../redux/question/question.actions";
import { validateInsertQuestion } from "../../../../utils/validation";
import { QuestionBasic } from "../../../../@types/question.interface";
import QuestionForm from "../../../../components/insert-question/insert-question.component";
import PreviewQuestion from "../../../../components/preview-question/preview-question.component";
import useAfterFetch from "../../../../effects/useAfterFetch.effect";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    questionNumber: number;
    insertQuestion: (data: IInsertQuestionPayload["data"]) => void;
    clearQuestions: () => void;
    setActiveTab: (tab: number) => void;
}

function InsertQuestionContainer({
    isFetching,
    errors,
    questionNumber,
    insertQuestion,
    clearQuestions,
    setActiveTab,
}: IProps) {
    const match = useRouteMatch<{ id: string; number: string }>();
    const id = parseInt(match.params.id);
    const fetching = useRef(false);

    const [question, setQuestion] = useState<QuestionBasic>({
        quiz_id: id,
        question_type_id: 0,
        question_number: 0,
        question_quiz: "",
        weight_score: 0,
        reason_answer: "",
        question_answer: [{ key: "" }],
        question_choice: [
            { answer: "" },
            { answer: "" },
            { answer: "" },
            { answer: "" },
        ],
    });

    useEffect(() => {
        setQuestion((prevState) => ({
            ...prevState,
            question_number: questionNumber,
        }));
    }, [questionNumber]);

    useEffect(() => {
        if (isFetching || errors) return;
        if (isFetching === false && fetching.current === true) setActiveTab(0);
    }, [isFetching, errors, setActiveTab]);

    const handleChange = (evt: any, name: string, index?: number) => {
        let val = evt;
        if (name !== "question_quiz" && name !== "question_choice" && name !== "reason_answer")
            val = evt.target.value;
        if (name === "question_type_id" || name === "weight_score")
            val = parseInt(val);
        if (val < 0) {
            val = 0;
            evt.target.value = 0;
        }
        let questionTemp = Object.assign({}, question);
        if (name === "question_quiz") {
            questionTemp.question_quiz = val;
            setQuestion((prevState) => ({
                ...prevState,
                question_quiz: questionTemp.question_quiz,
            }));
        } else if (name === "question_answer") {
            if (index === undefined) index = 0;
            if (questionTemp.question_type_id === 1) {
                questionTemp.question_answer[index].key = val;
            } else if (questionTemp.question_type_id === 2) {
                if (evt.target.checked) {
                    if (
                        questionTemp.question_answer.length === 1 &&
                        questionTemp.question_answer[0].key === ""
                    )
                        questionTemp.question_answer[0].key = val;
                    else
                        questionTemp.question_answer = questionTemp.question_answer.concat(
                            { key: val }
                        );
                } else {
                    let n = -2;
                    for (
                        let i = 0;
                        i < questionTemp.question_answer.length;
                        i++
                    )
                        if (questionTemp.question_answer[i].key === val) n = i;
                    questionTemp.question_answer.splice(n, 1);
                }
            }
            setQuestion((prevState) => ({
                ...prevState,
                question_answer: questionTemp.question_answer,
            }));
        } else if (name === "question_choice") {
            if (index === undefined) index = 0;
            questionTemp.question_choice[index].answer = val;
            setQuestion((prevState) => ({
                ...prevState,
                question_choice: questionTemp.question_choice,
            }));
        } else {
            setQuestion((prevState) => ({
                ...prevState,
                [name]: val,
            }));
        }
    };

    const [, hasSubmitted] = useAfterFetch(
        isFetching,
        undefined,
        clearQuestions
    );

    const [error, setError] = useState("");

    const handleClick = (evt: any) => {
        evt.preventDefault();
        setError(validateInsertQuestion(question, errors));
        if (validateInsertQuestion(question, errors) === "") {
            insertQuestion(question);
            hasSubmitted.current = true;
            fetching.current = true;
        }
    };

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="relative" />
            ) : (
                <>
                    <PreviewQuestion question={question} />
                    <QuestionForm
                        question={question}
                        handleChange={handleChange}
                        handleClick={handleClick}
                        error={error}
                    />
                </>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
}: GlobalState) => ({
    isFetching: isFetching.INSERT_QUESTION,
    errors: errors.INSERT_QUESTION,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    insertQuestion: (data: IInsertQuestionPayload["data"]) =>
        dispatch(fetchApi({ name: "INSERT_QUESTION", data: data })),
    clearQuestions: () => dispatch(QuestionActionAPI.clearQuestions()),
});

const InsertQuestionPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(InsertQuestionContainer);

export default InsertQuestionPage;
